const setLocalStorageObject = (key, object) => {
  try {
    localStorage.setItem(key, JSON.stringify(object));
  } catch (e) {
    return false;
  }
  return true;
};

export default setLocalStorageObject;
